import DashboardTable from '@components/pages/Dashboard/DashboardTable.component'
import React from 'react'
import { Modal } from 'react-bootstrap'

type TodaySideModalProps = {
  title: string
  data: any[]
  isOpen: boolean
  toggleModal: () => void
  isRowClickable?: boolean
  onClick?: () => void
}

function TodaySideModal({
  title,
  data,
  isOpen,
  toggleModal,
  isRowClickable,
  onClick,
}: TodaySideModalProps): React.ReactElement {
  const patientTemplate = (patient: any): React.ReactElement => {
    if (!patient || !patient.firstname || !patient.lastname) {
      return <div className="avatar-initials">N/A</div>
    }
    const firstnameInitial = patient.firstname.charAt(0).toUpperCase()
    const lastnameInitial = patient.lastname.charAt(0).toUpperCase()

    return (
      <div className="avatar-initials">{`${firstnameInitial}${lastnameInitial}`}</div>
    )
  }

  const providerTemplate = (patient: any): React.ReactElement => {
    if (!patient || !patient.provider) {
      return <div>Provider: Unknown</div>
    }
    return (
      <div>
        <span>Provider: </span>
        {patient.provider}
      </div>
    )
  }

  const column = [
    { field: 'startTime', header: 'Start time' },
    {
      field: 'firstname',
      header: 'Patient',
      template: patientTemplate,
    },
    {
      field: 'provider',
      header: 'Provider',
      template: providerTemplate,
    },
  ]

  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      className="today-side-modal modal-fullscreen"
    >
      <Modal.Header className="bg-custom3" closeButton>
        <Modal.Title className="text-white">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 m-0">
        <DashboardTable
          title={'Today Side Modal'}
          data={data}
          columns={column}
          allowMultiSorting={false}
          allowSorting={false}
          classNameTable="today-side-tbl"
          isRowClickable={isRowClickable}
          onClickRow={onClick}
        />
      </Modal.Body>
    </Modal>
  )
}

export default TodaySideModal
